import sample_1 from './sample_1.png';
import sample_2 from './sample_2.png';
import sample_3 from './sample_3.png';

export const forceEvoImpressions = {
    sample_1,
    sample_2,
    sample_3,
};
